import '@updater-components/tooltip';
import template from './moves.html';
import { STATES } from '../../../constants';
import { selectors, actions } from '../../../state';

const VERIFIED_MESSAGE = `You've verified you are who you say you are and now you can continue with your moving tasks.`;

class AccountMovesController {
  constructor(updStore) {
    'ngInject';
    const { connect, dispatch, getState } = updStore;

    Object.assign(this, {
      connect,
      dispatch,
      getState,
      goingToSummary: {},
    });
  }

  $onInit() {
    this.disconnect = this.connect(mapStateToThis)(this);
    this.dashboardUiSref = STATES.DASHBOARD;

    if (selectors.router.currentParamsVerified(this.getState())) {
      this.dispatch(actions.message.success(VERIFIED_MESSAGE));
    }
  }

  $onDestroy() {
    this.disconnect();
  }

  isCurrentMove(move) {
    return this.moveId === move.id;
  }

  goToVerify(move) {
    const success = () =>
      this.dispatch(actions.router.stateGo(STATES.MOVES_VERIFY));
    this._updateUserCurrentMoveId(move.id, success);
  }

  goToSummary(move) {
    const { id } = move;
    this.goingToSummary[id] = true;
    this.dispatch(
      actions.router.stateGo(STATES.MOVES_SUMMARY, { moveId: id })
    ).finally(() => (this.goingToSummary[id] = false));
  }

  _updateUserCurrentMoveId(moveId, success) {
    this.dispatch(
      actions.user.singleton(this.userId).update({
        current_move_id: moveId,
      })
    ).then(success);
  }
}

function mapStateToThis(state) {
  const { current } = selectors;
  const user = current.user(state);

  return {
    moveId: current.move(state).id(state),
    moves: user.moves(state).map(move => move.identity(state)),
    userId: current.user(state).id(state),
  };
}

export const AccountMovesComponent = {
  template,
  controller: AccountMovesController,
};
